import React from "react";
import {Faqsec1} from './components/Faqcomponent';
import PageHeader from "./components/PagesHeaderComponent/PageHeader";

const Faq = () => {
  return (
    <>
      <div id="faq_main">
      <PageHeader heading="Faq’s" />
        <div className="content_wrap">
          <Faqsec1 />
        </div>
      </div>
    </>
  );
};

export default Faq;